import * as Yup from 'yup';
import { isNull, isUndefined } from 'lodash';

const accidentAddressSchema = Yup.object().shape({
  accCountry: Yup.object().required('validationErrors.isRequired'),
  accState: Yup.object()
    .nullable()
    .when('isAccInArmenia', {
      is: true,
      then: Yup.object().required('validationErrors.isRequired'),
    }),
  accVillage: Yup.object()
    .nullable()
    .when(['accCountry', 'accState'], (accCountry, accState, schema) => {
      if (accCountry && accCountry.label === 'ARM' && (!isNull(accState) && !isUndefined(accState) && accState.label !== 'YR')) {
        return schema.required('validationErrors.isRequired');
      }
      if (accCountry && accCountry.label === 'ARM' && isNull(accState)) {
        return schema.required('validationErrors.isRequired');
      }
      return schema;
    }),
  accStreet: Yup.string()
    .required('validationErrors.isRequired')
    .isCorrectLanguage(),
});

export default accidentAddressSchema;
